module.exports = __webpack_public_path__ + "static/lunchtype22-medium-webfont-3686f2875a9d1bfc534059433a5a7684.woff";